import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {Body, H3} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import walletBadge from "@irati-web/wallet/src/images/wallet_badge.svg"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import {connect} from "@irati/store"
import dealsService from "@irati/deals/services/dealsGraph"
import {Wallet, Tag, DealStatus} from "@irati/types"

import StyledSectionHeader, {GridWrapper, Primary, Image} from "./styled/SectionHeader"
import {AvailableBalance} from "./styled/SpendSectionHeader"
import {navigateToCategoryWithTag} from "../../helpers/categories/navigateToCategoryWithTag"

const INITIAL_VARIABLES = {statuses: [DealStatus.On, DealStatus.Unavailable], limit: 1}

interface Props {
  wallet: Wallet,
  headerText: string,
  bodyText: string,
  className: string | null,
  tag: Tag | null
}

interface State {
  dealCount?: number
}

class SpendSectionHeader extends PureComponent<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  static defaultProps = {
    className: null,
    tag: null
  }

  state = {
    dealCount: undefined
  }

  componentDidMount() {
    dealsService
      .list({
        ...INITIAL_VARIABLES,
        tags: [this.props.tag.uuid]
      })
      .then(({count}) => {
        this.setState({
          dealCount: count
        })
      })
  }

  render() {
    const idNamespace = id("spend-section-header", this.props)

    const {
      headerText,
      className,
      wallet: {availableBalance, currency},
      tag
    } = this.props
    const {dealCount} = this.state

    return (
      <StyledSectionHeader id={idNamespace} className={className}>
        <GridWrapper>
          <Primary>
            <Image src={walletBadge} />
            <div>
              <H3 id={id("title", idNamespace)} paddingBottom={1}>
                {headerText}
              </H3>
              <Body small>
                {availableBalance === 0 ? (
                  <FormattedMessage id="perks.spendSectionHeader.subText.noBalance" />
                ) : (
                  <FormattedMessage
                    id="perks.spendSectionHeader.subText.withBalance"
                    values={{
                      availableBalance: (
                        <AvailableBalance>
                          <FormattedCurrency isCents={false} currency={currency} value={availableBalance} />
                        </AvailableBalance>
                      )
                    }} />
                )}
              </Body>
            </div>
          </Primary>
          {tag && (
            <Button cta onClick={() => navigateToCategoryWithTag(tag, this.context)}>
              <Flex alignItems="center">
                <FormattedMessage id="perks.spendSectionHeader.seeAllButton.text" values={{count: dealCount}} />
                <Icon icon={IconTypes.arrowRight} marginLeft />
              </Flex>
            </Button>
          )}
        </GridWrapper>
      </StyledSectionHeader>
    )
  }
}

const mapStateToProps = ({wallet}: {wallet: Wallet}) => ({wallet})

export default connect(mapStateToProps)(SpendSectionHeader)
